var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSeguros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.14,
    x2: 25,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25.24,
    x2: 25.24,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 25.87,
    x2: 25.87,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.22,50,0,38.78,0,25S11.22,0,25,0s25,11.21,25,25-11.22,25-25,25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.97,27.41c0,6.48-5.25,11.73-11.73,11.73s-11.73-5.25-11.73-11.73v-12.41l11.73-4.14,11.73,4.14v12.41ZM25.24,8.16l-14.44,4.81v14.44c0,7.97,6.46,14.44,14.44,14.44s14.44-6.46,14.44-14.44v-14.44l-14.44-4.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.22,23.61c-.53-.53-1.38-.53-1.91,0,0,0,0,0,0,0-.53.53-.53,1.38,0,1.91,0,0,0,0,0,0l4.86,4.86.08.08c.5.5,1.31.5,1.81,0,0,0,0,0,0,0l8.4-8.4c.5-.5.5-1.31,0-1.81,0,0,0,0,0,0l-.11-.11c-.5-.5-1.31-.5-1.81,0t0,0l-7.4,7.39-3.93-3.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeguros);
export default __webpack_public_path__ + "static/media/Icon_Seguros.b6d28fb72a9f311c45d36386651aeaf0.svg";
export { ForwardRef as ReactComponent };